import React from 'react';
export const PopupContainer = ({ children, className, }) => {
    return (React.createElement("div", { className: `popup-container ${className}` },
        React.createElement("div", { className: "overlay" }),
        React.createElement("div", { className: "popup-content" }, children)));
};
